/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDiscountFromJSON, ApiDiscountToJSON, } from './ApiDiscount';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadConversionFromJSON, ApiLeadConversionToJSON, } from './ApiLeadConversion';
import { ApiProductFromJSON, ApiProductToJSON, } from './ApiProduct';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiSaleItemFromJSON, ApiSaleItemToJSON, } from './ApiSaleItem';
import { ApiSaleOrderStatusFromJSON, ApiSaleOrderStatusToJSON, } from './ApiSaleOrderStatus';
import { ApiSaleOrderStatusHistoryFromJSON, ApiSaleOrderStatusHistoryToJSON, } from './ApiSaleOrderStatusHistory';
import { ApiSaleSourceFromJSON, ApiSaleSourceToJSON, } from './ApiSaleSource';
export function ApiSaleFromJSON(json) {
    return ApiSaleFromJSONTyped(json, false);
}
export function ApiSaleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conversion': !exists(json, 'conversion') ? undefined : ApiLeadConversionFromJSON(json['conversion']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'csvUploadSessionId': !exists(json, 'csvUploadSessionId') ? undefined : json['csvUploadSessionId'],
        'dataId': !exists(json, 'dataId') ? undefined : json['dataId'],
        'discounts': !exists(json, 'discounts') ? undefined : (json['discounts'].map(ApiDiscountFromJSON)),
        'gross': !exists(json, 'gross') ? undefined : json['gross'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'items': !exists(json, 'items') ? undefined : (json['items'].map(ApiSaleItemFromJSON)),
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'marginSynced': !exists(json, 'marginSynced') ? undefined : (new Date(json['marginSynced'])),
        'orderStatus': !exists(json, 'orderStatus') ? undefined : ApiSaleOrderStatusFromJSON(json['orderStatus']),
        'orderStatusHistory': !exists(json, 'orderStatusHistory') ? undefined : (json['orderStatusHistory'].map(ApiSaleOrderStatusHistoryFromJSON)),
        'products': !exists(json, 'products') ? undefined : (json['products'].map(ApiProductFromJSON)),
        'profitMargin': !exists(json, 'profitMargin') ? undefined : json['profitMargin'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'pushedToGoogleAnalytics': !exists(json, 'pushedToGoogleAnalytics') ? undefined : json['pushedToGoogleAnalytics'],
        'saleSource': !exists(json, 'saleSource') ? undefined : ApiSaleSourceFromJSON(json['saleSource']),
        'shipping': !exists(json, 'shipping') ? undefined : json['shipping'],
        'store': !exists(json, 'store') ? undefined : json['store'],
        'tax': !exists(json, 'tax') ? undefined : json['tax'],
        'transactionId': !exists(json, 'transactionId') ? undefined : json['transactionId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'webhookId': !exists(json, 'webhookId') ? undefined : json['webhookId'],
    };
}
export function ApiSaleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conversion': ApiLeadConversionToJSON(value.conversion),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'csvUploadSessionId': value.csvUploadSessionId,
        'dataId': value.dataId,
        'discounts': value.discounts === undefined ? undefined : (value.discounts.map(ApiDiscountToJSON)),
        'gross': value.gross,
        'id': value.id,
        'items': value.items === undefined ? undefined : (value.items.map(ApiSaleItemToJSON)),
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'marginSynced': value.marginSynced === undefined ? undefined : (value.marginSynced.toISOString()),
        'orderStatus': ApiSaleOrderStatusToJSON(value.orderStatus),
        'orderStatusHistory': value.orderStatusHistory === undefined ? undefined : (value.orderStatusHistory.map(ApiSaleOrderStatusHistoryToJSON)),
        'products': value.products === undefined ? undefined : (value.products.map(ApiProductToJSON)),
        'profitMargin': value.profitMargin,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'pushedToGoogleAnalytics': value.pushedToGoogleAnalytics,
        'saleSource': ApiSaleSourceToJSON(value.saleSource),
        'shipping': value.shipping,
        'store': value.store,
        'tax': value.tax,
        'transactionId': value.transactionId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'webhookId': value.webhookId,
    };
}
